<template>
	<div>

		<v-row class="mb-6">
			<v-col cols="8" md="6">
				<v-text-field
				v-model="search_query"
				:placeholder="$lang.TRIP_SEARCH"
				outlined
				rounded
				dense
				@keyup="getTripList"
				append-icon="mdi-magnify"
				hide-details
				single-line
				></v-text-field>
			</v-col>
			<v-col cols="4" md="6" class="text-right">
				<v-btn color="primary" outlined class="br-8 border-w-2 mr-2" @click="$router.push({name:'collection-history'})">
					<b>	
						{{$lang.VIEW_COLLECTION_HISTORY}}
					</b>
				</v-btn>
			</v-col>
			
		</v-row>

		<!-- trip List -->
		<div>
			<v-data-table 
			:headers="headers"
			:items="trip_list"
			:hide-default-footer="true"
			:disable-sort="true" 
			item-key="trip_id"
			:items-per-page="$keys.PAGE_LENGTH"
			class="elevation-1 custome-header-bg custome-table-body"
			:loading="table_loading"
			show-expand
			single-expand
			@item-expanded="loadShipments"
			>
			<template v-slot:item.delivery_agent="{ item }">
				<p>{{item.delivery_agent_name}}</p>
				<p>{{$lang.MOBILE_PREFIX}}{{item.delivery_agent_number}}</p>
			</template>

			<template v-slot:item.action="{ item }">
				<v-btn color="primary" @click="initiateCollection(item)">
					<b>{{$lang.COLLECT}}</b>
				</v-btn>
			</template>

			<template v-slot:expanded-item="{headers}">
				<td :colspan="headers.length" class="pa-0 ma-0" style="height:auto !important" >

					<div class="text-center py-10 bg-transparent blue-grey lighten-5" v-if="shipment_list.length<1">
						<v-progress-circular
						:size="50"
						color="primary"
						indeterminate
						></v-progress-circular>
					</div>

					<v-simple-table
					dense
					class="blue-grey lighten-5 inner-table"
					v-if="shipment_list.length>0"
					>
					<template v-slot:default>
						<tr class="pa-2 border-b">
							<th class="text-left pl-3 pt-2">{{$lang.SHIPMENT_ID}}</th>
							<th class="text-left">{{$lang.RETAILER_INFO}}</th>
							<th class="text-left">{{$lang.CHALLAN_NUMBER}}</th>
							<th class="text-left">{{$lang.AMOUNT}}</th>
							<th class="text-center">{{$lang.STATUS}}</th>
							<th class="text-left">{{$lang.WHOLESALER_INFO}}</th>
						</tr>
						<tr v-for="(shipment,i ) in filterList(shipment_list)" :key="i" class="border-b">
							<td class="text-left pl-3">{{shipment.shipment_id}}</td>
							<td class="text-left pt-2">
								<p>{{shipment.retailer_firm_name}}</p>
								<p>{{shipment.retailer_mobile_number}}</p>
							</td>
							<td class="pt-2">
								<p>{{shipment.challan_number}}</p>
							</td>	
							<td class="pt-2">
								<p v-if="shipment.final_status==$keys.RETURN ||shipment.final_status==$keys.PARTIAL_RETURN">0.00</p>
								<p v-else >{{shipment.shipment_amount}}</p>
							</td>
							<td class="text-center">
								<span v-if="shipment.final_status" :class="getClassSatus(shipment.final_status)">{{shipment.final_status}}</span>
								<span v-if="!shipment.final_status" :class="getClassSatus($lang.IN_TRANSIT)">{{$lang.IN_TRANSIT}}</span>
							</td>
							<td class="pt-2">
								<p>{{shipment.wholesaler_firm_name}}</p>
								<p>{{shipment.wholesaler_mobile_number}}</p>
							</td>

						</tr>

					</template>
				</v-simple-table>
			</td>
		</template>


		<!-- empty slot  -->
		<template v-slot:no-data>
			<empty-list :message="$lang.EMPTY_SHIPMENTS" />
		</template>

	</v-data-table>

	<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
	@input="getTripList"></v-pagination>
</div>

<collection-verification-dialog :dialog="dialog"/>

</div>
</template>
<script>
export default {
	components: {
		CollectionVerificationDialog: () => import('./child/CollectionVerificationDialog.vue'),
	},
	data() {
		return {
			page_number: 1,
			total_page_count: 1,
			search_query:"",
			singleSelect: false,
			trip_list: [],
			table_loading: false,
			btn_loading: false,
			shipment_list:[],
			headers: [
			{ text: 'Delivery Agent', align: 'start', value: 'delivery_agent' },
			{ text: 'Trip Info', value: 'trip_id' },
			{ text: 'Returns', value: 'return_shipment_count' },
			{ text: 'Amount', value: 'trip_collection_amount' },
			{ text: '', value: 'action', width:50, align: 'end' },
			{ text: '', value: 'data-table-expand' },
			],
			dialog:{
				flag:false,
				trip:null,
			}


		}
	},

	created() {
		this.$store.dispatch('drawer/setActiveTab', this.$route.name)
		this.getTripList(false)
	},
	methods: {

		/* fetching shipment list */
		getTripList(is_cancel=true) {
			this.$store.dispatch('setPageLoader', true)
			const self = this
			let params = {
				page_number: this.page_number,
				page_length: this.$keys.PAGE_LENGTH,
				is_history: this.$keys.FALSE,
				search_query:this.search_query,
			};
			self.table_loading = true

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success) {
					this.trip_list = response.data.trip_list
					this.total_page_count = response.data.total_page_count
				}
			};
			const finallyHandler = () => {
				self.table_loading = false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET(self, self.$urls.GET_COLLECTION_TRIP_LIST, params, successHandler, null, null, finallyHandler,is_cancel)
		},
		/* loadt the shipment list  on row expand */
		/* call this api for  first time data load and   for refesh data */
		loadShipments(obj) {
			const self= this
			let params = {
				trip_id:obj.item.trip_id,
			};
			const successHandler = (response) => {
				if (response.data.success) {
					self.shipment_list = response.data.shipment_list;
				}
			};
			const finallyHandler = () => {
			};
			self.request_GET(
				self,
				self.$urls.GET_COLLECTION_TRIP_LIST,
				params,
				successHandler,
				null,
				null,
				finallyHandler
				);
		},

		/* open confirmation dialog to confirm  collection*/ 
		initiateCollection(trip){
			const self = this
			self.btn_loading = true
			var form = new FormData();
			form.append("trip_id", trip.trip_id);


			const successHandler = (response) => {
				if (response.data.success) {
					this.ConfirmCollect(trip,response.data.transaction_id)
				}

			};
			const finallyHandler = () => {
				self.btn_loading = false
			};
			this.request_POST(self, self.$urls.COLLECT_TRIP, form, successHandler, null, null, finallyHandler)
		},
		/* filter shipment list */
		filterList(shipment_list){
			const self=this
			return shipment_list.filter(function(item) {
				return item.final_status!=self.$keys.DELIVERED_WITH_CREDIT;
				// return shipment_list;
			});
		},
		/* show confirm colleciton popup*/ 
		ConfirmCollect(trip,transaction_id){
			this.dialog.trip=trip
			this.dialog.transaction_id=transaction_id
			this.dialog.flag=true
		},

		/* Drop Shipment API call*/
		collect() {
			const self = this
			self.btn_loading = true

			var form = new FormData();
			form.append("shipment_id_list", self.shipment_id_list);
			// form.append("deivery_agent_id", self.delivery_agent.id);
			form.append("is_collect", true);


			const successHandler = (response) => {
				if (response.data.success) {
					self.getShipmentList()
					this.getDeliveryAgents()
					this.$store.dispatch('snackbar/setSnackbar', { flag: true, text: "Shipments dropped at warehouse", color: 'success' })
				}

			};
			const finallyHandler = () => {
				self.btn_loading = false
			};
			this.request_POST(self, self.$urls.CHANGE_SHIPMENT_STATUS, form, successHandler, null, null, finallyHandler)
		},
	}
}
</script>